<template>
  <component-container :object="object"
                       help-url="https://jmeter.apache.org/usermanual/component_reference.html#HTTP_Cache_Manager">
    <el-form-item label-width="0" prop="clearEachIteration">
      <el-checkbox v-model="object.clearEachIteration.value" :disabled="object.controlledByThreadGroup.value">
        {{ t('wm.configurations.cache_manager.clear_cache_per_iter') }}
      </el-checkbox>
    </el-form-item>
    <el-form-item label-width="0" prop="controlledByThreadGroup">
      <el-checkbox v-model="object.controlledByThreadGroup.value">
        {{ t('wm.configurations.cache_manager.cache_clear_controlled_by_threadgroup') }}
      </el-checkbox>
    </el-form-item>
    <el-form-item label-width="0" prop="useExpires">
      <el-checkbox v-model="object.useExpires.value">
        {{ t('wm.configurations.cache_manager.use_expires') }}
      </el-checkbox>
    </el-form-item>
    <el-form-item :label="t('wm.configurations.cache_manager.cache_manager_size')" prop="maxSize">
      <el-input v-model="object.maxSize.value" type="number"></el-input>
    </el-form-item>
  </component-container>
</template>

<script>

import ComponentContainer from "@/components/ComponentContainer";
import VariableFieldSet from "@/components/variables/VariableFieldSet";
import CacheManager from "./index";
import Locale from "@/mixins/locale";
import ComponentFieldSet from "@/components/ComponentFieldSet";

export default {
  name: "CacheManager",
  components: {ComponentFieldSet, VariableFieldSet, ComponentContainer},
  mixins: [Locale],
  props: {
    object: CacheManager
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>
